import { render } from "./InquiryTypeList.vue?vue&type=template&id=cb54d11c"
import script from "./InquiryTypeList.vue?vue&type=script&lang=js"
export * from "./InquiryTypeList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__